import { render } from "./CourseRegisteredCardTooltip.vue?vue&type=template&id=b2abac20&scoped=true"
import script from "./CourseRegisteredCardTooltip.vue?vue&type=script&lang=js"
export * from "./CourseRegisteredCardTooltip.vue?vue&type=script&lang=js"

import "./CourseRegisteredCardTooltip.vue?vue&type=style&index=0&id=b2abac20&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2abac20"]])

export default __exports__